// extracted by mini-css-extract-plugin
module.exports = {"body":"Subscriptions_body__4N6qW","footer":"Subscriptions_footer__3sUg0","container":"Subscriptions_container__1nyp_"};